import React from 'react'
import { useOrderAccountsContext } from 'app/workorder/contexts/use-order-account-context'

export interface ProductStock {
  LocalStock: number
  TotalStock: number
  hasLoadedAvailability: boolean
}

export const useCallMeBack = (product?: ProductStock) => {
  const { displayRules } = useOrderAccountsContext()
  const outOfStock = product && product.hasLoadedAvailability && product.LocalStock <= 0 && product.TotalStock <= 0
  return React.useMemo(() => displayRules?.RuleDisplayProductAvailabilityCallback && outOfStock, [outOfStock, displayRules])
}
